export default "__VITE_ASSET__Csf2P_0L__"